(function ($) {
	'use strict';

	function getSwiperElements() {
		return Array.prototype.slice.call(document.querySelectorAll('.swiper')).filter(function (el) {
			return !el.closest('.wp-block-slider');
		});
	}

	function ensureSwiperStructure(el) {
		// Si le wrapper existe déjà, on ne fait rien
		if (el.querySelector('.swiper-wrapper')) return true;

		// Collecter les slides enfants (exclure les éléments de navigation)
		const candidates = Array.prototype.slice.call(el.children).filter(function (child) {
			if (!child || child.nodeType !== 1) return false;
			const cls = child.className || '';
			return !/swiper-button-next|swiper-button-prev|swiper-pagination|swiper-scrollbar/.test(cls);

		});

		if (!candidates || candidates.length === 0) return false;

		var wrapper = document.createElement('div');
		wrapper.className = 'swiper-wrapper';

		candidates.forEach(function (node) {
			wrapper.appendChild(node);
			if (!node.classList.contains('swiper-slide')) {
				node.classList.add('swiper-slide');
			}
		});

		if (el.firstChild) el.insertBefore(wrapper, el.firstChild);
		else el.appendChild(wrapper);

		return true;
	}

	function isValidSwiperEl(el) {
		ensureSwiperStructure(el);
		if (!el || el.nodeType !== 1) return false;
		const wrapper = el.querySelector('.swiper-wrapper');
		if (!wrapper) return false;
		const slides = wrapper.querySelectorAll('.swiper-slide');
		return !!(slides && slides.length > 0);
	}

	function initSwiperInstance() {
		const els = getSwiperElements();
		if (!els || els.length === 0 || typeof window.Swiper === 'undefined') return false;

		let initialized = false;
		els.forEach(function (el, idx) {
			if (!isValidSwiperEl(el)) return;

			const options = {
				slidesPerView: 1,
				spaceBetween: 20,
				loop: true,
				autoplay: {delay: 5000},
				breakpoints: {
					540: {slidesPerView: 1},
					1024: {slidesPerView: 2},
					1600: {slidesPerView: 3}
				}
			};

			// Chercher les boutons dans plusieurs endroits
			let next = el.querySelector('.swiper-button-next');
			let prev = el.querySelector('.swiper-button-prev');
			let extraNextButtons = [];
			let extraPrevButtons = [];

			// Si non trouvé, chercher dans le parent
			if (!next || !prev) {
				const wrapper = el.parentElement;
				if (wrapper) {
					if (!next) next = wrapper.querySelector('.swiper-button-next');
					if (!prev) prev = wrapper.querySelector('.swiper-button-prev');
				}
			}

			// Si non trouvé, chercher dans le grand-parent (section)
			if (!next || !prev) {
				const section = el.closest('section');
				if (section) {
					if (!next) next = section.querySelector('.swiper-button-next');
					if (!prev) prev = section.querySelector('.swiper-button-prev');
				}
			}

			if (next || prev) {
				const nav = {};
				if (next) nav.nextEl = next;
				if (prev) nav.prevEl = prev;
				if (Object.keys(nav).length) {
					// Empêche Swiper d'ajouter ses SVG .swiper-navigation-icon par défaut.
					options.navigation = {...nav, addIcons: false};
				}
			}

			// Si plusieurs paires de navigation existent (ex: desktop + mobile),
			// on connecte aussi les boutons secondaires à la même instance.
			const section = el.closest('section');
			if (section) {
				extraNextButtons = Array.prototype.slice.call(section.querySelectorAll('.swiper-button-next')).filter(function (btn) {
					return btn !== next;
				});
				extraPrevButtons = Array.prototype.slice.call(section.querySelectorAll('.swiper-button-prev')).filter(function (btn) {
					return btn !== prev;
				});
			}

			try {
				const swiper = new Swiper(el, options);

				extraNextButtons.forEach(function (btn) {
					if (btn.dataset.swiperNavBound === '1') return;
					btn.dataset.swiperNavBound = '1';
					btn.addEventListener('click', function (event) {
						event.preventDefault();
						swiper.slideNext();
					});
				});

				extraPrevButtons.forEach(function (btn) {
					if (btn.dataset.swiperNavBound === '1') return;
					btn.dataset.swiperNavBound = '1';
					btn.addEventListener('click', function (event) {
						event.preventDefault();
						swiper.slidePrev();
					});
				});

				initialized = true;
			} catch (e) {
				console.error('Swiper init failed:', e);
			}
		});

		return initialized;
	}

	function init() {
		if (typeof window.Swiper === 'undefined') {
			console.warn('Swiper library is not loaded and seems not included in the page.');
			return;
		}
		initSwiperInstance();
	}

	// Initialisation au chargement du document
	if (typeof jQuery !== 'undefined') {
		jQuery(window).on('load', init);
	} else {
		window.addEventListener('load', init);
	}

	// Exposer la fonction pour réinitialisation manuelle
	window.kaleliaInitSwipers = initSwiperInstance;

})(jQuery);
